import type { ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import { FormGroupContainer } from '@/components/FormContainer'
import styles from './MutatorAmount.module.css'

export interface MutatorAmountProps {
  /**
   * The number input, or the formula editor.
   */
  children?: ReactNode
  isExprMode: boolean
  onToggleMode: () => unknown
  error?: string
  isDisabled?: boolean
  /**
   * The mode button gets `${testId}-mode-button`.
   */
  testId?: string
}

/**
 * A service item mutator's amount: a number, or a formula.
 */
export function MutatorAmount({
  children,
  isExprMode,
  onToggleMode,
  error,
  isDisabled,
  testId,
}: MutatorAmountProps) {
  return (
    <FormGroupContainer
      error={error}
      help={
        isExprMode && (
          <>
            You can use <code>Value</code> to refer to the current quantity of
            the item.
          </>
        )
      }
    >
      <div className={styles.root}>
        <div className={styles.input}>{children}</div>
        <IconButton
          name={isExprMode ? 'hashtag' : 'chat-code'}
          label={isExprMode ? 'Switch to number mode' : 'Switch to Ryno mode'}
          size={14}
          isDisabled={isDisabled}
          onPress={onToggleMode}
          testId={testId && `${testId}-mode-button`}
        />
      </div>
    </FormGroupContainer>
  )
}
